import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

const baseURL = process.env.REACT_APP_BASE_URL
const dashboardURL = `${baseURL}/api/dashboard/get-associate-dashboard`
const associatesByMonthURL = `${baseURL}/api/dashboard/get-associate-by-month`
const associatesByGradeURL = `${baseURL}/api/dashboard/get-associate-by-grade`
const associatesURL = `${baseURL}/api/dashboard/get-associates?isActive=true&recordLimit=10`

export const fetchAssociateDashboard = createAsyncThunk(
  'dashboard/fetchAssociateDashboard',
  async (_, { rejectWithValue, getState }) => {
    try {
      const state = getState()
      const accessToken = state.auth.accessToken

      const response = await axios.get(dashboardURL, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
      })
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data || 'An error occurred')
    }
  }
)

export const fetchAssociatesByMonth = createAsyncThunk(
  'dashboard/fetchAssociatesByMonth',
  async (_, { rejectWithValue, getState }) => {
    try {
      const state = getState()
      const accessToken = state.auth.accessToken

      const response = await axios.get(associatesByMonthURL, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
      })
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data || 'An error occurred')
    }
  }
)

export const fetchAssociatesByGrade = createAsyncThunk(
  'dashboard/fetchAssociatesByGrade',
  async (_, { rejectWithValue, getState }) => {
    try {
      const state = getState()
      const accessToken = state.auth.accessToken

      const response = await axios.get(associatesByGradeURL, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
      })
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data || 'An error occurred')
    }
  }
)

export const fetchTopAssociates = createAsyncThunk(
  'dashboard/fetchTopAssociates',
  async (_, { rejectWithValue, getState }) => {
    try {
      const state = getState()
      const accessToken = state.auth.accessToken

      const response = await axios.get(associatesURL, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
      })
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data || 'An error occurred')
    }
  }
)

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState: {
    activeCount: 0,
    inactiveCount: 0,
    associatesByMonth: [],
    associatesByGrade: [],
    topAssociates: [],
    totalAssociateCount: 0,
    status: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAssociateDashboard.pending, (state) => {
        state.status = 'loading'
        state.error = null
      })
      .addCase(fetchAssociateDashboard.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.activeCount = action.payload.data.activeCount || 0
        state.inactiveCount = action.payload.data.inactiveCount || 0
      })
      .addCase(fetchAssociateDashboard.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action.payload || 'An unexpected error occurred.'
      })
      .addCase(fetchAssociatesByMonth.pending, (state) => {
        state.status = 'loading'
        state.error = null
      })
      .addCase(fetchAssociatesByMonth.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.associatesByMonth =
          action.payload.data.getAssociateByMonthModels || []
        state.totalAssociateCount = action.payload.data.totalAssociateCount || 0
      })
      .addCase(fetchAssociatesByMonth.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action.payload || 'An unexpected error occurred.'
      })
      .addCase(fetchAssociatesByGrade.pending, (state) => {
        state.status = 'loading'
        state.error = null
      })
      .addCase(fetchAssociatesByGrade.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.associatesByGrade = action.payload.data || []
      })
      .addCase(fetchAssociatesByGrade.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action.payload || 'An unexpected error occurred.'
      })
      .addCase(fetchTopAssociates.pending, (state) => {
        state.status = 'loading'
        state.error = null
      })
      .addCase(fetchTopAssociates.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.topAssociates = action.payload.data || []
      })
      .addCase(fetchTopAssociates.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action.payload || 'An unexpected error occurred.'
      })
      .addCase('RESET', () => ({
        activeCount: 0,
        inactiveCount: 0,
        associatesByMonth: [],
        associatesByGrade: [],
        topAssociates: [],
        totalAssociateCount: 0,
        status: 'idle',
        error: null,
      }))
  },
})

export default dashboardSlice.reducer
